import { render, staticRenderFns } from "./authGroupSubjectDialog.vue?vue&type=template&id=409528c4&scoped=true&lang=pug"
import script from "./authGroupSubjectDialog.vue?vue&type=script&lang=js"
export * from "./authGroupSubjectDialog.vue?vue&type=script&lang=js"
import style0 from "./authGroupSubjectDialog.vue?vue&type=style&index=0&id=409528c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409528c4",
  null
  
)

export default component.exports